export const bindScroll = (element) => {
    if (!element) {
        return ;
    }
    element.pointY = 0;

    element.addEventListener("touchstart", (e) => {
        e.stopPropagation();

        const point = e.touches ? e.touches[0] : e;
        element.pointY = point.pageY;
    })

    element.addEventListener("touchmove", (e) => {
        e.stopPropagation();

        const point = e.touches ? e.touches[0] : e;
        const deltaY = point.pageY - element.pointY;
        const absDistY = Math.abs(deltaY);

        if (deltaY > 0) {
            element.scrollTop -= absDistY;
        } else if (deltaY < 0) {
            element.scrollTop += absDistY;
        } 
        element.pointY = point.pageY;
    })

}

